import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import state from './state'
import actions from './actions'
import getters from './getters'


Vue.use(Vuex)

const store = new Vuex.Store({
    modules,
    actions,
    getters,
    state
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js